<template>
    <div class="d-flex flex-column align-items-center w-100">
        <div class="section-header text-center px-0">
            <div v-if="recaptchaEnabled && displayRecaptcha">
                <turnstile-widget ref="turnstileWidget" execution="execute" action="form-submission" @verified="handleRecaptchaToken" @errored="handleRecaptchaError" @expired="clearRecaptcha" @timedOut="clearRecaptcha" @retrying="clearRecaptcha" @interactiveStart="pauseRecaptchaWait" @interactiveEnd="resumeRecaptchaWait"></turnstile-widget>
                <validation-message v-if="recaptchaMessage" :message="recaptchaMessage"></validation-message>
            </div>
            <terms-checkbox v-model="termsAccepted" :disabled="loading || unknownStatus" @displayTerms="displayTerms"></terms-checkbox>
            <validation-message v-if="termsMessage" :message="termsMessage" class="mb-2"></validation-message>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import { mapActions, mapMutations } from 'vuex';
    import { ErrorHelper } from '@/helpers/ErrorHelper'
    import { BookingAddMixin } from '@/mixins/Booking/BookingAddMixin'
    import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin';
    import { SiteBookingResourceOrderSettingMixin } from '@/mixins/Booking/SiteBookingResourceOrderSettingMixin';
    import { PreferredResourceCacheMixin } from '@/mixins/Booking/PreferredResourceCacheMixin';
    import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue';
    import TurnstileWidget from '../TurnstileWidget.vue';
    import TermsAndConditionsCheckbox from '../TermsAndConditionsCheckbox.vue';

    export default {
        name: 'BookingAdd',
        mixins: [BookingAddMixin, SiteBookingSettingMixin, SiteBookingResourceOrderSettingMixin, PreferredResourceCacheMixin],
        computed: {
            participants() {
                const { selectedPets, resourceIds } = this.bookingUploadModel;

                // Map of resourceId to its index in resourcesForRegisteredClients
                const resourceIdToIndexMap = new Map();
                this.resourcesForRegisteredClients.forEach((id, index) => {
                    resourceIdToIndexMap.set(id, index);
                });

                const sortedResourceIdsInMap = resourceIds.sort((a, b) => resourceIdToIndexMap.get(a) - resourceIdToIndexMap.get(b));
                
                if(!(selectedPets.length > 0 && sortedResourceIdsInMap.length > 0)) return [];

                if(!!this.siteBookingSettingSinglePetResourceEnabled){
                    // Track assigned resource IDs
                    const assignedResourceIds = new Set();

                    // Assign preferred resourceIds first
                    const result = selectedPets.map(pet => {
                        const preferredResource = this.preferredResources.find(
                            res => res.petId === pet.petId
                        );
                        let resourceId = '';
                        if (preferredResource) {
                            const preferredResourceId = preferredResource.resourceId;

                            // Check if preferred resourceId is in sortedResourceIdsInMap and not already assigned
                            if ( sortedResourceIdsInMap.includes(preferredResourceId) && !assignedResourceIds.has(preferredResourceId)) {
                                resourceId = preferredResourceId;
                                assignedResourceIds.add(preferredResourceId);
                            }
                        }
                        return {
                            ...pet,
                            resourceId,
                            serviceItems: pet.serviceItems.map(item => ({
                                ...item,
                                quantity: 1,
                            })),
                        };
                    });

                    // Assign remaining unassigned pets with available resourceIds
                    let availableResourceIds = sortedResourceIdsInMap.filter(
                        id => !assignedResourceIds.has(id)
                    );

                    result.forEach(pet => {
                        if (!pet.resourceId && availableResourceIds.length > 0) {
                            // Assign the next available resourceId
                            pet.resourceId = availableResourceIds.shift();
                        }
                    });

                    return result;
                } else {
                  return selectedPets.map((pet, i) => ({
                        ...pet,
                        resourceId: this.getPreferredResource(selectedPets, sortedResourceIdsInMap),
                        serviceItems: pet.serviceItems.map(item => ({ ...item, quantity: 1 }))
                    }));
                }
            }
        },
        watch: {
            participants(value) {
                this.setParticipants(value);
            }
        },
        beforeDestroy() {
            this.setParticipants([]);
        },
        methods: {
            ...mapMutations('BookingUpload', [
                'setParticipants'
            ]),
            ...mapActions('Booking', [
                'addBookingAuthenticated'
            ]),
            tryAddBooking() {
                const self = this;
                self.error = '';
                if(!self.bookingAddModelValid || !self.selectedSiteId) {
                    return;
                }
                self.addBookingAuthenticated({siteId: this.selectedSiteId, payload: self.bookingAddModel, router: self.$router })
                    .catch(error => { 
                        self.error = ErrorHelper.getError(error);
                        self.resetRecaptcha();
                    });
            },
            getPreferredResource(selectedPets, sortedResourceIdsInMap){
                let selectedResourceId = sortedResourceIdsInMap[0];
                if (this.preferredResources.length === 0) {
                    return selectedResourceId;
                }
                for (const pet of selectedPets) {
                    const preferredResource = this.preferredResources.find(pr => pr.petId === pet.petId);
                    if (preferredResource) {
                        // Check if the resourceId in preferredResources exists in sortedResourceIdsInMap
                        if (sortedResourceIdsInMap.includes(preferredResource.resourceId)) {
                            selectedResourceId = preferredResource.resourceId;
                            break;
                        }
                    }
                }
                return selectedResourceId;
            }
        },
        components: {
            'validation-message': ValidationMessage,
            'turnstile-widget': TurnstileWidget,
            'terms-checkbox': TermsAndConditionsCheckbox
        }
    }
</script>
